<form [formGroup]="form" class="row">
  <!-- Caso validacion documento  -->

  <div class="col-12">
    <div>
      <p class="center">
        ¿Los documentos corresponden a un trabajador del banco?
      </p>
      <mat-radio-group formControlName="is" aria-label="Select an option">
        <div class="center">
          <mat-radio-button
            (click)="changeIsWorker(true)"
            class="primary-radiobutton margin30"
            value="si"
            >Si
          </mat-radio-button>
          <mat-radio-button
            (click)="changeIsWorker(false)"
            class="primary-radiobutton margin30"
            value="no"
            >No
          </mat-radio-button>
        </div>
      </mat-radio-group>

      <div class="center" *ngIf="form.value.is == 'si'">
        <mat-form-field class="margin6" appearance="outline">
          <mat-label>Nombre y apellido</mat-label>
          <input matInput formControlName="nombre" />
        </mat-form-field>
        <mat-form-field class="margin6" appearance="outline">
          <mat-label>NM</mat-label>
          <input matInput formControlName="nm" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="separador col-12"></div>

  <div class="col-12">
    <div class="divRadio">
      <!-- <p class="textoRadio">Contacto a la entidad emisora del documento y solicita validación</p>
            <mat-radio-group class="checleft" formControlName="contactar_entidad_emisora" aria-label="Select an option">
               <mat-radio-button value="Si">Si</mat-radio-button>
               <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
             </mat-radio-group> -->
      <div class="opcionCheck">
        <p>Contacto a la entidad emisora del documento y solicita validación</p>
        <mat-checkbox
          formControlName="contactar_entidad_emisora"
        ></mat-checkbox>
      </div>

      <mat-form-field appearance="outline" class="dateInput">
        <mat-label>Fecha</mat-label>
        <input matInput formControlName="fecha1" [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <!-- <mat-error *ngIf="form.get('fecha').hasError('required')"
                  >La fecha es <strong>requerida </strong></mat-error
                > -->
      </mat-form-field>
    </div>
    <div class="divRadio">
      <div class="opcionCheck">
        <p>
          Comisión especialista para investigación precencial en la institución
          emisora del documento
        </p>
        <mat-checkbox formControlName="comision_especialista"></mat-checkbox>
      </div>

      <!-- <p class="textoRadio">Comisión especialista para investigación precencial en la institución emisora del documento</p>
           <mat-radio-group class="checleft" formControlName="comision_especialista" aria-label="Select an option">
               <mat-radio-button value="Si">Si</mat-radio-button>
               <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
             </mat-radio-group> -->
      <mat-form-field appearance="outline" class="dateInput">
        <mat-label>Fecha</mat-label>
        <input matInput formControlName="fecha2" [matDatepicker]="picker2" />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="divRadio">
      <div class="opcionCheck">
        <p>
          Elabora y entrega comunicación interna el especialista, autorizado la
          solicitud de información
        </p>
        <mat-checkbox
          [labelPosition]="'after'"
          formControlName="entreaga_comunucacion_interna"
        ></mat-checkbox>
      </div>
      <!-- <p class="textoRadio">Elabora y entrega comunicación interna el especialista, autorizado la solicitud de información</p>
           <mat-radio-group class="checleft" formControlName="entreaga_comunucacion_interna" aria-label="Select an option">
               <mat-radio-button value="Si">Si</mat-radio-button>
               <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
             </mat-radio-group> -->
      <mat-form-field appearance="outline" class="dateInput">
        <mat-label>Fecha</mat-label>
        <input matInput formControlName="fecha3" [matDatepicker]="picker3" />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker3"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker3></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="divRadio">
      <div class="opcionCheck">
        <p>Recibe respuesta de la entidad emisora</p>
        <mat-checkbox
          [labelPosition]="'after'"
          formControlName="respuesta_entidad"
        ></mat-checkbox>
      </div>
      <!-- <p class="textoRadio">Recibe respuesta de la entidad emisora</p>
           <mat-radio-group class="checleft" formControlName="respuesta_entidad" aria-label="Select an option">
               <mat-radio-button value="Si">Si</mat-radio-button>
               <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
             </mat-radio-group> -->
      <mat-form-field appearance="outline" class="dateInput">
        <mat-label>Fecha</mat-label>
        <input matInput formControlName="fecha4" [matDatepicker]="picker4" />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker4"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker4></mat-datepicker>
      </mat-form-field>
    </div>
    <!-- <mat-form-field  appearance="outline" class="col-6">
            <mat-label>Tipo Documento</mat-label>
            <input formControlName="tipo_docuemnto"  matInput>
          </mat-form-field>
          <mat-form-field  appearance="outline" class="col-6">
            <mat-label>Ente Emisor del Documento</mat-label>
            <input formControlName="ente"  matInput>
          </mat-form-field>
       <mat-form-field  appearance="outline" class="col-6">
         <mat-label>C.I. de la persona</mat-label>
         <input formControlName="ci_persona"  matInput>
       </mat-form-field>
       <mat-form-field  appearance="outline" class="col-6">
         <mat-label>Nombres y Apellidos Persona</mat-label>
         <input formControlName="nombre_apellido"  matInput>
       </mat-form-field> -->
  </div>
  <div class="separador col-12"></div>
  <h3 class="titleDocuemnto">Documentos</h3>
  <div>
    <form [formGroup]="formTable" class="form_table" (ngSubmit)="addData()">
      <div
        class="style-input-default input_table margin_right"
        data-text="Nombre documento*"
        [ngClass]="{ error: verificateInput('red_social') }"
      >
        <input
          type="text"
          placeholder="Nombre documento"
          formControlName="nombre"
        />
      </div>
      <div class="margin_right" style="display: flex">
        <p>Valido</p>
        <mat-radio-group
          class="checleft"
          formControlName="valido"
          aria-label="Select an option"
        >
          <mat-radio-button value="Si">Si</mat-radio-button>
          <mat-radio-button style="margin-left: 10px" value="No"
            >No</mat-radio-button
          >
        </mat-radio-group>
      </div>
      <div
        class="margin_right style-input-default input_table"
        data-text="Comentario *"
        [ngClass]="{ error: verificateInput('nombre_cuenta') }"
      >
        <input
          type="text"
          placeholder="Comentario"
          formControlName="comentario"
        />
      </div>
      <button
        *ngIf="!status"
        class="margin_right"
        type="submit"
        [disabled]="formTable.invalid || submit"
      >
        <i class="fas fa-plus"></i>
      </button>
    </form>
  </div>

  <div class="task_content_table">
    <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
      <ng-container matColumnDef="nombre">
        <th class="header-options" mat-header-cell *matHeaderCellDef>
          Documento
        </th>
        <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
      </ng-container>

      <ng-container matColumnDef="valido">
        <th class="header-options" mat-header-cell *matHeaderCellDef>Valido</th>
        <td mat-cell *matCellDef="let element">{{ element.valido }}</td>
      </ng-container>

      <ng-container matColumnDef="comentario">
        <th class="header-options" mat-header-cell *matHeaderCellDef>
          Comentario
        </th>
        <td mat-cell *matCellDef="let element">{{ element.comentario }}</td>
      </ng-container>

      <!-- <ng-container matColumnDef="opciones">
        <th class="header-options" mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div class="options">
            <button class="delete" (click)="removerCuenta(i)"><i class="fas fa-times"></i></button>
          </div>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    [pageSize]="5"
    [showFirstLastButtons]
  ></mat-paginator>

  <!--    <div class="col-12">
       <p class="textTitle">Documento no es valido / presenta irregularidad</p>
       <div class="divRadio">
            <p>Remite el caso a un investigador para su resolución</p>
            <button
            class="button"
            
            (click)="remireAsuntosInternos()"
          >
            Remitir Asuntos Internos
        </button>
       </div>
        <div class="divRadio">
        <p>Realizar seguimiento sobre avances del caso</p>
        <button
        class="button"
        
        (click)="seguir()"
      >
        Seguimiento
    </button>
   </div> 
   </div>-->
  <!-- <div class="separador col-12"></div>
   <div class="col-12 " >
    <p class="textTitle">Documento no es valido / presenta irregularidad</p>
     <div>
      <p class="textoRadio">Informa al solicitante atravez de correo electronico</p>
      <div class="row">
        <div class="col-6" style="display: flex;padding: 0px;">
          <mat-radio-group class="checleft" formControlName="contactar_entidad_emisora" aria-label="Select an option">
            <mat-radio-button value="Si">Si</mat-radio-button>
            <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
          </mat-radio-group>
          <mat-form-field appearance="outline" class="dateInputValidacion">
            <mat-label>Fecha</mat-label>
            <input matInput formControlName="fecha2" [matDatepicker]="picker2" />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="divRadio col-6">
          <button
          class="button"
          
          (click)="finalizar()"
        >
          Validacion finalizada
      </button>
      </div>
      </div>
     
     </div>
      
   </div> -->
</form>
